module.exports = __webpack_public_path__ + "img/fa-regular-400.4b831aa.svg";